var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "toolbox-a",
    d: "M16.0013203,8.58966849 L15.9942136,8.59670455 L19.7642136,4.82670455 C20.2584246,4.33249355 21.0942349,4.48478015 21.3823807,5.12153838 C22.5835831,7.77601244 22.0149385,10.8969636 19.9547056,12.9571965 C18.0622609,14.8496412 15.2748355,15.4835583 12.7760569,14.6432883 L6.32842712,21.0909181 C5.10947571,22.3098695 3.13316498,22.3098695 1.91421356,21.0909181 C0.695262146,19.8719667 0.695262146,17.895656 1.91421356,16.6767046 L8.36184337,10.2290747 C7.52157333,7.73029621 8.15549049,4.94287076 10.0479351,3.05042612 C12.1081681,0.990193168 15.2291192,0.4215486 17.8835933,1.62275096 C18.5203515,1.91089673 18.6726381,2.74670712 18.1784271,3.24091811 L14.4155337,7.00381149 L16.0013203,8.58966849 Z M17.4013203,10.0179542 C16.6236333,10.7802399 15.3790074,10.7802399 14.5942136,10.0109181 L12.9871775,8.40381133 C12.2248917,7.62612431 12.2248917,6.38149835 12.9871775,5.60381133 L15.5593635,3.03155458 C14.0737834,2.86381754 12.5579232,3.36886513 11.4621487,4.46463968 C9.99055373,5.93623465 9.58437904,8.16548548 10.4423807,10.0615384 C10.6139811,10.440749 10.5327461,10.8865991 10.2384271,11.1809181 L3.32842712,18.0909181 C2.89052429,18.5288209 2.89052429,19.2388017 3.32842712,19.6767046 C3.76632996,20.1146074 4.47631073,20.1146074 4.91421356,19.6767046 L11.8242136,12.7667046 C12.1185326,12.4723856 12.5643827,12.3911506 12.9435933,12.562751 C14.8396462,13.4207526 17.068897,13.014578 18.540492,11.542983 C19.6362715,10.4472034 20.1413187,8.93133447 19.9735748,7.44574787 L17.4013203,10.0179542 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "toolbox-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#toolbox-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#toolbox-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#toolbox-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.721805a5a6857e71cc4cd199225726f4.svg";
export { ForwardRef as ReactComponent };